import { render } from "./OfficePage.vue?vue&type=template&id=43abd461"
import script from "./OfficePage.vue?vue&type=script&lang=js"
export * from "./OfficePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__